import { Injectable, Inject } from '@angular/core';
import { WINDOW } from '@src/window.provider';
import { downgradeToAJSService, AJSRootScope} from 'ib-web-commons/utils';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom, firstValueFrom } from 'rxjs';

import { cloneDeep } from 'lodash';
import { AJSGiftCardsCommonsModalService, GiftCardsCommonsModalServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-modal-service-bridge.service';
import { AJSGiftCardsCommonsNewHttpUtilsErrorService, GiftCardsCommonsNewHttpUtilsErrorServiceType } from '@shared/services/upgrades/ib-gift-cards-commons-new-http-utils-error-bridge.service';
import { AJSGiftCardsCommonsKeepAliveUtilsService, GiftCardsCommonsKeepAliveUtilsServiceType } from '@shared/services/upgrades/ib-gift-cards-keep-alive-utils-bridge.service';
import { AJSGiftCardsIbCPermanentUserService, GiftCardsIbCPermanentUserServiceType } from '@shared/services/upgrades/ib-gift-cards-permanent-user-service-bridge.service';
import { AJSGiftCardsDatalayerUtilsService, GiftCardsDatalayerUtilsServiceType } from '@shared/services/upgrades/ib-gift-cards-datalayer-utils-service-bridge.service';
import { AJSGiftCardsDigitalDataService, GiftCardsDigitalDataServiceType } from '@shared/services/upgrades/ib-gift-cards-digital-data-service-bridge.service';
import { AJSGiftCardsIbCNewPaymentAvailiabilityService,  GiftCardsIbCNewPaymentAvailiabilityServiceType } from '@shared/services/upgrades/ib-gift-cards-new-payment-availiability-service-bridge.service';
import { AJSGiftCardsCurrencyService, GiftCardsCurrencyServiceType } from '@shared/services/upgrades/ib-gift-cards-currency-service-bridge.service';
import { GiftCardsImportModelService } from '../ib-gift-cards-import/ib-gift-cards-import-model.service';
import { GiftCardsSessionStorageService } from '@src/app/core/services/ib-gift-cards-session-storage/gift-cards-session-storage.service';
import { GiftCardsGenericProxyService } from '@src/app/core/services/ib-gift-cards-generic-proxy/ib-gift-cards-generic-proxy.service';
@Injectable({
    providedIn: 'root'
})
export class GiftCardsConfigurationService {
    constructor (
        @Inject(AJSGiftCardsCommonsModalService) private  CommonsModalService: GiftCardsCommonsModalServiceType,
        @Inject(AJSGiftCardsCommonsNewHttpUtilsErrorService) private CommonsNewHttpUtilsErrorService: GiftCardsCommonsNewHttpUtilsErrorServiceType,
        @Inject(AJSGiftCardsCommonsKeepAliveUtilsService) private CommonsKeepAliveUtilsService: GiftCardsCommonsKeepAliveUtilsServiceType,
        @Inject(AJSGiftCardsIbCPermanentUserService) private IbCPermanentUserService: GiftCardsIbCPermanentUserServiceType,
        @Inject(AJSGiftCardsDatalayerUtilsService) private DatalayerUtilsService: GiftCardsDatalayerUtilsServiceType,
        @Inject(AJSGiftCardsDigitalDataService) private DigitalDataService: GiftCardsDigitalDataServiceType,
        @Inject(AJSGiftCardsIbCNewPaymentAvailiabilityService) private IbCNewPaymentAvailiabilityService: GiftCardsIbCNewPaymentAvailiabilityServiceType,
        @Inject(AJSGiftCardsCurrencyService) private CurrencyService: GiftCardsCurrencyServiceType,
        @Inject(AJSRootScope) private rootScope: any,
        private translateService: TranslateService,
        private GiftCardsImportModelService: GiftCardsImportModelService,
        private GiftCardsSessionStorageService: GiftCardsSessionStorageService,
        private GiftCardsGenericProxyService: GiftCardsGenericProxyService
    ) {}

    getAvailability = (contributionAmount?: number, flowId?: string): angular.IPromise<Types.AvailabilityGiftCards|any> => {

        const endpoint = flowId ? GiftCardsAppConstants.DEFAULT_ENDPOINTS.AVAILABILITY_CONTRIBUTION.replaceAll('{{flowId}}', flowId) : GiftCardsAppConstants.DEFAULT_ENDPOINTS.AVAILABILITY;
        const trackingCode: string = this.GiftCardsSessionStorageService.get('TrackingCode');
        const market = trackingCode.split('/')[1];

        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        return new Promise ((resolve, reject)=>{
            const postData = {
                type: 'GIFTCARD',
                market: market
            };

            const getAvailabilitySuccess = (response: Types.ProxyResponse) :void => {
                if (response && response.code === 200) {
                    const data : Types.AvailabilityGiftCards  = this.GiftCardsImportModelService.transformInfo( <Types.AvailabilityGiftCards>response.data);
                    this.GiftCardsSessionStorageService.set('flowId', data.flowId);
                    resolve(this.customResponse(data, contributionAmount));
                } else {
                    getAvailabilityError(response);
                }
                
            };
            const getAvailabilityError = (error: CommonsErrorsModel.ErrorDataGeneral) :void => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };
            firstValueFrom(this.GiftCardsGenericProxyService.postGeneric(`${endpoint}`, postData, headerConfig )).then(getAvailabilitySuccess).catch(getAvailabilityError);
        });
    };

    emailsTheme  = (datalayer: Record<string, any>, emails: Types.dataPutResponse):object =>{
        const dataLayerExtend:any = cloneDeep(datalayer);

        for (const email of emails.emailsHashed) {
            if(email.code === 'emailSender' ) {
                dataLayerExtend.hashEIDEmailSender = email.value;
            }else if(email.code === 'emailReceiver') {
                dataLayerExtend.hashEIDEmailReceiver = email.value;
            }else if(email.code === 'emailDeliveryHand') {
                dataLayerExtend.hashEIDEmailDeliveryHand = email.value;
            }
        }
        const cardDestiny = this.GiftCardsSessionStorageService.get('cardDestiny');
        if (cardDestiny) {
            const theme = this.GiftCardsSessionStorageService.get('theme');
            dataLayerExtend.theme = theme;
        }

        return dataLayerExtend;
    };

    generateDataForPostMaximunDateAllowed = (date, campaignSelectedId) => {
        const confirmationDigitalInfo: Types.confirmationDigitalInfo = this.GiftCardsSessionStorageService.get('confirmationDigitalInfo');
        return {
            type: 'GIFTCARD',
            market: confirmationDigitalInfo.Market,
            deliveryDate: this.calculateUTC0DateTimeGiftCardGroup(date).replace(' ', 'T'),
            campaignsToUpdate: [campaignSelectedId]
        };
    };

    formatDateByMarket = (dateToFormat) => {
        let day, month, year;
        const confirmationDigitalInfo: Types.confirmationDigitalInfo = this.GiftCardsSessionStorageService.get('confirmationDigitalInfo');
        const dateArray = dateToFormat.split('/');
        confirmationDigitalInfo.Market !== 'ES' ? [month, day, year]  = dateArray : [day, month, year]  = dateArray;
        return `${day}/${month}/${year}`;
    };

    postMaximunDateAllowed = (data, flowId): angular.IPromise<Types.AvailabilityGiftCards|any> => {
        const endpoint = (GiftCardsAppConstants.DEFAULT_ENDPOINTS.GET_MAXIMUN_DATE_ALLOWED).replace('{flowId}', flowId);
        this.CommonsModalService.showWaitingModal('ib-modal-loading-plane', 'ib-modals ib-modals--transparent ib-modals--loading-page', true);
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        return new Promise ((resolve, reject)=> {
            const GetMaximunDateAllowedSuccess = (response: Types.ProxyResponse) => {
                if (response && response.code === 200) {
                    this.CommonsModalService.finishWaiting();
                    resolve(response);
                } else {
                    GetMaximunDateAllowedError(response);
                }
                
            };
            const GetMaximunDateAllowedError = (error: CommonsErrorsModel.ErrorDataGeneral) => {
                this.CommonsModalService.finishWaiting();
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };
            firstValueFrom(this.GiftCardsGenericProxyService.postGeneric(`${endpoint}`, data, headerConfig)).then(GetMaximunDateAllowedSuccess).catch(GetMaximunDateAllowedError);
        });
    };

    putGiftCard = (data:Types.PutGiftCardRequest, flowId : string, dataDatalayer?:Types.dataDatalayer, otherPerson?: boolean): Promise<any | Types.ErrorResponse> => {
        const endpoint = GiftCardsAppConstants.DEFAULT_ENDPOINTS.GIFCARD.replace('{flowId}', flowId);
        return new Promise ((resolve, reject)=> {
            const headerConfig = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'accept': '*/*'
                }
            };
            const putGiftCardSuccess = async (response: Types.ProxyResponse) => {
                if (response && response.code === 200) {
                    this.GiftCardsSessionStorageService.set('flowId', flowId);
                    this.CommonsKeepAliveUtilsService.initKeepAlive();
                    this.DigitalDataService.addDigitalDataInfo({GitCardPrice: dataDatalayer.importePagoCliente ? dataDatalayer.importePagoCliente : dataDatalayer.importeTarjetaRegalo, GiftCardValue: dataDatalayer.importeTarjetaRegalo, GiftCardBeneficiary: otherPerson ? 'otro' : 'usuario'});
                    this.DatalayerUtilsService.sendDatalayerEvent(GiftCardsAppConstants.DATALAYER_EVENT_TYPES.VIEW);
                    this.DigitalDataService.emitViewEvent();
                    this.updatePaymentContext(flowId);
                } else {
                    putGiftCardError(response);
                }
                
                setTimeout(() => {
                    this.rootScope.$broadcast('updateDatalayer');            
                    this.rootScope.$broadcast('updateDigitalData');
                    this.rootScope.$broadcast('sendUpdateToMonetate');
                }, 100);
                resolve(response);
            };
            const putGiftCardError = (error: CommonsErrorsModel.ErrorDataGeneral) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };
            firstValueFrom(this.GiftCardsGenericProxyService.putGeneric(`${endpoint}`, data, headerConfig)).then(putGiftCardSuccess).catch(putGiftCardError);
        });

    };

    updatePaymentContext = async (flowId: string): Promise<any | Types.ErrorResponse> => {
        const endpoint = GiftCardsAppConstants.DEFAULT_ENDPOINTS.UPDATE_PAYMENT_CONTEXT.replace('{flowId}', flowId);
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };
        const postData = {
            'redirection': {
                'success': {
                    'url': endpoint,
                    'data': '',
                    'method': ''
                },
                'failure': {
                    'url': endpoint,
                    'data': '',
                    'method': ''
                }
            }
        };
        return new Promise ((resolve, reject)=> {
            const updatePaymentContextSuccess = async (response: Types.ProxyResponse) => {
                if (response && response.code === 200) {
                    await this.checkPermanentUserAndGoPayment();
                    resolve(response);
                } else {
                    updatePaymentContextError(response);
                }
                

            };
            const updatePaymentContextError = (error: CommonsErrorsModel.ErrorDataGeneral) => {
                this.CommonsNewHttpUtilsErrorService.controlError(error, reject);
            };

            firstValueFrom(this.GiftCardsGenericProxyService.postGeneric(`${endpoint}`, postData, headerConfig))
                .then(updatePaymentContextSuccess)
                .catch(updatePaymentContextError);

        });
    };


    private checkPermanentUserAndGoPayment = async (): Promise<void> => {
        this.IbCPermanentUserService.checkPermanentUserFlow()
            .then(async () => {
                this.CommonsModalService.finishWaiting();
                const isNewPaymentAvailiability = await this.IbCNewPaymentAvailiabilityService.isNewPaymentAvailiability();
                const paymentsURI = isNewPaymentAvailiability ? GiftCardsAppConstants.PAGES_ROUTES.NEWPAYMENTS : GiftCardsAppConstants.PAGES_ROUTES.PAYMENTS;
                let baseUrl = window.location.href;
                let paymentsFinalUrl = baseUrl.replace(baseUrl.split('#!')[1], paymentsURI);
                window.location.href = paymentsFinalUrl;
            })
            .catch(() => {});
    };

    getRouteParams = (model, GiftCardsUtilService) => {
        model.urlParams = {
            language: GiftCardsUtilService.getParameterByName('language'),
            market: GiftCardsUtilService.getParameterByName('market'),
            id: GiftCardsUtilService.getParameterByName('id'),
            code: GiftCardsUtilService.getParameterByName('code')
        };
    };
    initializeModel = (): Types.ConfigurationModel => {

        return{
            destinyGift: {
                destiny: 'other-person',
                otherPerson: true
            },
            themeGift: {
                theme: null
            },
            participationCheckboxGroup: 'false',
            groupAvailability: false,
            giftCardName: '',
            shippingInfo: {
                shippingOptionEmail: true,
                emailEmailReceiver: null,
                emailEmailSender: null,
                shippingOptionSender : false,
                senderEmailSender : null,
                delivery: {
                    time: '',
                    dateTime: ''
                }
            },
            importGift: null,
            destinataryInfo: {
                destinataryName: '',
                message: '',
                remitterName:''
            },
            importInfo: null,
            urlParams: {
                language: '',
                market:'',
                id:'',
                code:''
            },
            contributionCardData: {
                giftCardName: '',
                senderName: '',
                senderEmail: '',
                receiverName: '',
                receiverEmail: '',
                theme: '',
                message: '',
                deliveryHandEmail: '',
                deliveryDate: '',
                deliverySimpleDate: '',
                expiryDate: '',
                expirySimpleDate: '',
                amount: null,
                currency: {
                    code: '',
                    description: '',
                    symbol: '',
                    alignment: '',
                    groupingSeparator: '',
                    decimalSeparator: '',
                    decimals: null,
                    recommendedDisplay: ''
                }
            }

        };
    };
    /**
     * Returns the market from url
     * @returns {string} - returns an string made from params
     */
    getParameterByName = (name: string, url?: string): string => {
        if (!url) url = window.location.href;
        name = name.replace(/[\\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'gi' );
        const results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return null;
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };
    transformDate = (date) => {
        const partes = date.split('/');
        const {Market}: Types.confirmationDigitalInfo  = this.GiftCardsSessionStorageService.get('confirmationDigitalInfo'),
            hour = date.split(' ')[1],
            language = this.getParameterByName('language');
        const esFormatoDMY = (Market === 'ES' || Market === 'AR') && language === 'es';
        let day, month, year;
 
        if (esFormatoDMY) {
            [day, month, year] = partes;
        } else {
            [month, day, year] = partes;
        }
        return `${year.split(' ')[0]}-${month}-${day} ${hour}`;
    };

    calculateUTC0DateTimeGiftCardGroup = (dateFromForm: string) => {
        const localDate = new Date();
        const minutesDifferenceWithUTC = localDate.getTimezoneOffset();
        const dateTemp: Date = new Date(dateFromForm);
        const diferenceHours = parseInt(localDate.getTimezoneOffset().toString().replace('-', '').replace('+', ''));
        minutesDifferenceWithUTC > 0 ? dateTemp.setHours(dateTemp.getHours() + (diferenceHours / 60)).toString()  : dateTemp.setHours(dateTemp.getHours() - (diferenceHours / 60 ) );
        const dateReturn = `${dateTemp.getFullYear()}-${(dateTemp.getMonth() +1).toString().length == 1 ? `0${(dateTemp.getMonth() +1)}`: `${(dateTemp.getMonth() +1)}`}-${dateTemp.getDate().toString().length == 1 ? `0${dateTemp.getDate()}`: `${dateTemp.getDate()}`} ${dateTemp.getHours().toString().length == 1 ? `0${dateTemp.getHours()}`: `${dateTemp.getHours()}`}:00`;
        return dateReturn;
    }; 
    defineDeliveryType = (configurationModel: Types.ConfigurationModel): Types.deliveryType => {
        const typesOfShipping = {
            byEmail: (configurationModel?.shippingInfo?.shippingOptionEmail),
            byHand: (configurationModel?.shippingInfo?.shippingOptionSender)
        };
        return typesOfShipping;
    };

    addDeliveryType = (request: Types.PutGiftCardRequest, deliveryType: Types.deliveryType): Types.PutGiftCardRequest => {
        request.body.delivery.type = deliveryType;
        return request;
    };

    transformData = (data : Types.ConfigurationModel, giftCardflow?:string): Types.PutGiftCardRequest => {
        
        let request: Types.PutGiftCardRequest, dateTime;
        const deliveryType = this.defineDeliveryType(data);
        const subtype = (data.participationCheckboxGroup == 'true' || giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) ? GiftCardsAppConstants.SUBTYPES.GROUP : GiftCardsAppConstants.SUBTYPES.INDIVIDUAL;
        const time = (data.participationCheckboxGroup == 'true' || giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) ? GiftCardsAppConstants.TIMES.SCHEDULED : GiftCardsAppConstants.TIMES.NOW;
        
        const emailSender = giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION ? data.destinataryInfo.emailEmailReceiver : data.shippingInfo.emailEmailSender;
        const senderName = giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION ? data.destinataryInfo.destinataryName :  data.destinataryInfo.remitterName;
        const receiverName = giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION ? null : data.destinataryInfo.destinataryName;
        const giftCardName = (giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) ? data.contributionCardData.giftCardName : data.giftCardName;

        if(data.participationCheckboxGroup == 'true') {
            dateTime= this.calculateUTC0DateTimeGiftCardGroup(data.shippingInfo.delivery.dateTime);
        }else if (giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) {
            dateTime= this.transformDate(data.contributionCardData.deliveryDate);
        }
        const mineGiftCard = (data: Types.ConfigurationModel): Types.PutGiftCardRequest=> {
            return {
                type: GiftCardsAppConstants.TYPE.GIFTCARD,
                body: {
                    subtype: GiftCardsAppConstants.SUBTYPES.OWN,
                    giftCardAmount: {
                        amount: data.importGift.amount,
                        currency: data.importInfo.currency.code,
                        campaignId: data.importGift.campaignId.toString()
                    },
                    email: data.shippingInfo.emailEmailSender
                }
            };
        };
        const individualGiftCard = (data: Types.ConfigurationModel): Types.PutGiftCardRequest=> {
            return {
                type: GiftCardsAppConstants.TYPE.GIFTCARD,
                body: {
                    subtype: subtype,
                    giftCardName: giftCardName,
                    giftCardAmount: {
                        amount: data.importGift.amount,
                        currency: data.importInfo.currency.code,
                        campaignId: data.importGift.campaignId
                    },
                    theme: data.themeGift.theme,
                    sender: {
                        name: senderName,
                        email: emailSender
                    },
                    receiver: {
                        name: receiverName,
                        email: data.shippingInfo.emailEmailReceiver
                    },
                    message: data.destinataryInfo.message,
                    emailDeliveryHand: data.shippingInfo.shippingOptionSender ? emailSender : null,
                    delivery: {
                        time: time,
                        dateTime: dateTime
                    },
                    notificationOnContribution: false
                }
            };
        };

        const contribution = (data: Types.ConfigurationModel): Types.PutGiftCardRequest=> {
            return {
                type: GiftCardsAppConstants.TYPE.GIFTCARD,
                body: {
                    subtype: subtype,
                    giftCardName: data.contributionCardData.giftCardName,
                    giftCardAmount: {
                        amount: data.importGift.amount,
                        currency: data.importInfo.currency.code,
                        campaignId: data.importGift.campaignId
                    },
                    theme: data.contributionCardData.theme,
                    sender: {
                        name: data.destinataryInfo.destinataryName,
                        email: data.destinataryInfo.emailEmailReceiver
                    },
                    receiver: {
                        name: data.contributionCardData.receiverName,
                        email: data.contributionCardData.receiverEmail
                    },
                    message: data.contributionCardData.message,
                    emailDeliveryHand: data.contributionCardData.deliveryHandEmail,
                    delivery: {
                        time: time,
                        dateTime: dateTime
                    },
                    notificationOnContribution: true
                }
            };
        };
        if(giftCardflow == GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) {
            request = contribution(data);
            data.giftCardName = data.contributionCardData.giftCardName;
            data.flow = giftCardflow;
            this.GiftCardsSessionStorageService.set('giftCardsConfigurationInfo', data);
        }else if(data.destinyGift.destiny == GiftCardsAppConstants.PUT_GIFT_CARD.MINE) {
            request = mineGiftCard(data);
            data.flow = giftCardflow;
            this.GiftCardsSessionStorageService.set('giftCardsConfigurationInfo', data);
        }else if(data.destinyGift.destiny == GiftCardsAppConstants.PUT_GIFT_CARD.OTHER) {
            request = individualGiftCard(data);
            data.flow = giftCardflow;
            this.addDeliveryType(request, deliveryType);
            this.GiftCardsSessionStorageService.set('giftCardsConfigurationInfo', data);
        }
        
        return request;
    };

    customResponse = async (availability: Types.AvailabilityGiftCards, contributionAmount: number) => {

        const transformConditions = {
            allConditionsEquals: availability.allConditionsEquals,
            campaigns: availability.campaigns,
            selectedCondition: availability.selectedCondition,
            groupAllConditionsEquals: availability.groupAllConditionsEquals,
            groupCampaigns: availability.groupCampaigns
        };

        availability.conditionInfo = await this.transformConditions(transformConditions, availability, contributionAmount);
        return availability;

    };

    orderCampaigns = async (campaigns: Types.CampaignsList[]) =>{
        const campaingsFormated:Types.CampaignsList[] = [];
        let custom:Types.CampaignsList;
        let findCustom = false;

        const giftCardOtherImportText = await lastValueFrom(this.translateService.get('GIFT_CARD_CONDITION_MODAL_OTHER_IMPORT'));
        campaigns.forEach((campaign) => {
            
            if (!findCustom && campaign.text === giftCardOtherImportText) {
                findCustom = true;
                custom = campaign;
            } else if (campaign && campaign.text !== giftCardOtherImportText) {
                campaingsFormated.push(campaign);
            }
        });
        campaingsFormated.push(custom);
        return campaingsFormated;
    };

    transformConditions = async (conditions: Types.ConditionSuccess, imports, contributionAmount?:number) =>{
        let findCampaign = false, findCustomCampaign = false, findGroupCampaign = false, findGroupCustomCampaign = false, infoFixedPriceRoute, infoCampaignRoute;
        const campaignTextTranslate = await lastValueFrom(this.translateService.get('GIFT_CARD_CONDITION_MODAL_OTHER_IMPORT'));
        if(contributionAmount > 0) {
            infoFixedPriceRoute = 'groupFixedPrices';
            infoCampaignRoute = 'groupCampaigns';
        }else {
            infoFixedPriceRoute = 'fixedPrices';
            infoCampaignRoute = 'campaigns';
        }
        imports.fixedPrices.forEach((fixed) => {
            findCampaign = false;
            findGroupCampaign = false;
            conditions.campaigns.forEach((campaign) => {
                if (!findCampaign && !campaign.text && campaign.campaignId === fixed.campaignId ) {
                    findCampaign = true;
                    campaign.text = fixed.price;
                }
                if (!findCustomCampaign && imports.customPrice && campaign.campaignId === imports.customPrice.campaignId) {
                    findCustomCampaign = true;
                    campaign.text = campaignTextTranslate;
                }
            });
        });
        imports.groupFixedPrices.forEach(fixed => {
            conditions.groupCampaigns.forEach((campaign)=>{
                if (!findGroupCampaign && !campaign.text && campaign.campaignId === fixed.campaignId ) {
                    findCampaign = true;
                    campaign.text = fixed.price;
                }
                if (!findGroupCustomCampaign && imports.groupCustomPrice && campaign.campaignId === imports.groupCustomPrice.campaignId) {
                    findCustomCampaign = true;
                    campaign.text = campaignTextTranslate;
                    
                }
            });

        });

        if(imports.groupCustomPrice) {
            conditions.campaigns = await this.orderCampaigns(conditions[infoCampaignRoute]);
        }
        conditions.selectedCondition = cloneDeep(conditions[infoCampaignRoute][0]);
        if(contributionAmount > 0 && imports[infoFixedPriceRoute][0]) {
            conditions.selectedCondition.totalContribution = this.CurrencyService.formatPrice(imports.currency, imports[infoFixedPriceRoute][0]?.amount + contributionAmount, false, false, false);
            conditions.selectedCondition.text = imports[infoFixedPriceRoute][0].price;
        }
        if(conditions.allConditionsEquals) {
            conditions.selectedCondition.text = imports[infoFixedPriceRoute][0].price;
        }
        return conditions;
    };
}
downgradeToAJSService('GiftCardsConfigurationService', GiftCardsConfigurationService, 'ib-gift-cards-service-module');
